module.exports = __webpack_public_path__ + "img/logo.cf63d227.jpg";